import * as React from 'react';
import * as _ from 'lodash';
import NumericInput from './NumericInput';
import utils from '../../../utils/cartItemUtils';
import math from '../../../../redux/modules/utils/math';
export default function () {
    function scopeHasSubscribeDiscount1(props) {
        var hasSubscribeDiscount = props.price !== props.regularPrice;
        return React.createElement('div', { 'className': 'price' }, hasSubscribeDiscount ? React.createElement('span', {
            'className': 'subscribe-discount',
            'key': '1848'
        }, '$', math.toFixed(props.regularPrice)) : null, React.createElement('span', {}, '$', math.toFixed(props.price)), hasSubscribeDiscount && props.discountPercentage > 0 ? React.createElement('span', {
            'className': 'discount-message',
            'key': '2019'
        }, '\n                Subscribers ', React.createElement('br', {}), ' save ', props.discountPercentage, '%\n            ') : null);
    }
    function scopeProps2() {
        var props = this.props;
        return React.createElement('div', { 'className': 'cart-item-mobile' }, React.createElement('div', { 'className': 'thumbnail' }, props.type !== 'plan' ? React.createElement('img', {
            'src': props.thumbnail.default,
            'key': '324'
        }) : null, !props.thumbnail.default && props.type !== 'plan' ? React.createElement('img', {
            'src': props.thumbnail.boxThumb,
            'key': '400'
        }) : null, props.type === 'plan' ? React.createElement('div', {
            'className': 'plan-icon',
            'key': '505'
        }, React.createElement('i', { 'className': 'icon-monster-' + props.ordered.rank })) : null, React.createElement('div', { 'className': 'remove-item' }, React.createElement('div', {
            'onClick': () => props.removeCartItemDispatcher(props.id),
            'className': 'cross'
        }, React.createElement('i', { 'className': 'icon-x-hover' })))), React.createElement('section', { 'className': 'first-section' }, React.createElement('div', { 'className': 'description' }, React.createElement('div', { 'className': 'type blue' }, React.createElement('span', {}, utils.getNaturalType(props.orderedModel, props.ordered))), React.createElement('div', { 'className': 'title' }, React.createElement('span', {}, utils.getTitle(props.orderedModel, props.ordered))), React.createElement('div', { 'className': 'quantity' }, React.createElement('span', {}, 'Quantity:'), props.type === 'physical' ? React.createElement(NumericInput, {
            'value': props.quantity,
            'id': props.id,
            'update': (pk, qt) => props.updateCartItemQuantity(pk, qt),
            'disabled': props.loading > 0,
            'key': '1251'
        }) : null, props.type !== 'physical' ? React.createElement('div', {
            'className': 'static-quantity',
            'key': '1561'
        }, React.createElement('span', {}, this.props.quantity)) : null)), scopeHasSubscribeDiscount1.apply(this, [props])));
    }
    return scopeProps2.apply(this, []);
}